import { EVCharger, EVChargerOutput, EVChargerOutputPort } from './evcharger';
import { EVChargeTariff } from './evcharge-tariff';
import { EVCStation } from '../location/evcstation';
import { Rate } from '../rate';
import moment from "moment";

export class EVCBayOutlet {
    id: string
    name: string
    output: EVChargerOutput
    guns: EVCBayOutletGun[]
    tariff: EVChargeTariff
    tariffs: EVCBayOutletTariff[]
    qrCodeValue: string
    cmsTagNo: string

    constructor(id: string, name: string, output: EVChargerOutput, guns: EVCBayOutletGun[], tariff: EVChargeTariff, tariffs : EVCBayOutletTariff[], qrCodeValue: string, cmsTagNo: string) {
        this.id = id
        this.name = name
        this.output = output
        this.guns = guns
        this.tariff = tariff
        this.tariffs = tariffs
        this.qrCodeValue = qrCodeValue
        this.cmsTagNo = cmsTagNo
    }
}

export class EVCBayOutletTariff {
    id: string
    tariffCode: string
    effectiveOn: Date  
    effectiveTill: Date
    status?: EVCBayOutletTariffStatus
    
    constructor(id: string, tariffCode: string, effectiveOn: Date, effectiveTill: Date) {
        this.id = id
        this.tariffCode = tariffCode
        this.effectiveOn = effectiveOn
        this.effectiveTill = effectiveTill
        this.status = (moment(effectiveOn).isSame(effectiveTill, 'day'))? new EVCBayOutletTariffStatus("I","Inactive"): new EVCBayOutletTariffStatus("A","Active")
    }
 
}

export class EVCBayOutletTariffStatus{
    id: string
    name: string

    constructor(id: string, name: string) {
        this.id = id
        this.name = name
    }
}


export class EVCBayOutletGun {
    id: string
    name: string
    image?: string
    title?: string
    subTitle?: string
    detail?: string
    titleGroup?: string
    // contextual attributes
    setup?: EVCStationBaySetup
    rate? : Rate
    outlet?: EVCBayOutlet
    port?: EVChargerOutputPort
    bayDetails?: BayDetailsForReservation

    constructor(id: string, name: string, image?: string, title?: string, subTitle?: string, detail?: string, titleGroup?: string, bayDetails?: BayDetailsForReservation) {
        this.id = id
        this.name = name
        this.image = image
        this.title = title
        this.subTitle = subTitle
        this.detail = detail
        this.titleGroup = titleGroup
        this.bayDetails = bayDetails
    }
}

export class EVCStationBaySetup {
    id: string
    station: EVCStation | {id: string}
    charger: EVCharger | {id: string}
    outlets: EVCBayOutlet[]
    status: EVCStationBayStatus
    effectiveOn?: Date  
    effectiveTill?: Date

    constructor(id: string, station: EVCStation | {id: string}, charger: EVCharger | {id: string}, outlets: EVCBayOutlet[], status: EVCStationBayStatus, effectiveOn?: Date, effectiveTill?: Date) {
        this.id = id
        this.station = station
        this.charger = charger
        this.outlets = outlets 
        this.status = status   
        this.effectiveOn = effectiveOn
        this.effectiveTill = effectiveTill
    }
}

export class EVCStationBayStatus {
    id: string
    name: string

    constructor(id: string, name: string) {
        this.id = id
        this.name = name
    }
}

export class BayDetailsForReservation {
    bayName: string
    connectorName: string
    constructor(bayName: string, connectorName: string) {
        this.bayName = bayName
        this.connectorName = connectorName
    }
}